/**
 * @generated SignedSource<<05b5b447dcdc73dcbeec677a7e0a2069>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaperBookmarkButtonFragment$data = {
  readonly bookmarkCount: number;
  readonly id: string;
  readonly viewerBookmarked: boolean | null | undefined;
  readonly " $fragmentType": "PaperBookmarkButtonFragment";
};
export type PaperBookmarkButtonFragment$key = {
  readonly " $data"?: PaperBookmarkButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaperBookmarkButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaperBookmarkButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookmarkCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerBookmarked",
      "storageKey": null
    }
  ],
  "type": "Paper",
  "abstractKey": null
};

(node as any).hash = "f51a7f0a4342f6faca66dabe9091d88b";

export default node;
